import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/surprise': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM248 456C137.7 456 48 366.3 48 256S137.7 56 248 56 448 145.7 448 256 358.3 456 248 456zM248 280C212.7 280 184 308.7 184 344S212.7 408 248 408 312 379.3 312 344 283.3 280 248 280zM200 208C200 190.3 185.7 176 168 176S136 190.3 136 208 150.3 240 168 240 200 225.7 200 208zM328 176C310.3 176 296 190.3 296 208S310.3 240 328 240 360 225.7 360 208 345.7 176 328 176z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/surprise.js
// module id = uo5W
// module chunks = 144